import { Injectable} from '@angular/core';
import { catchError, EMPTY, filter, map, Observable, of, tap} from 'rxjs';
import { ContractModel, ContractWrapperModel } from '../../../models/contract.model';
import { ContractsService } from '../../../services/api/contracts.service';
import { ContractDataService } from './contract-data.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogsMTService } from '../../../services/modal/dialogs-mt.service';
import { TokenService } from '../../../services/token.service';
@Injectable({
    providedIn: 'root'
})
export class ContractFormService {
  public showHistoryList:boolean = false
  constructor(
    private contractsService:ContractsService,
    private contractDataService:ContractDataService,
    private translateService:TranslateService,
    private dialogsMTService:DialogsMTService,
    private tokenService:TokenService,
  ) { }
  saveEditedContractDescription(contractId:string, items: {name:string,description:string}) :Observable<{contract: ContractWrapperModel;  message: string;}> {
    return this.contractsService.editContract(contractId, items)
    .pipe(tap(res => this.contractDataService.subContractEditedNameOrDesc.next(res.contract.contract)))
  }
  deleteMemberFromContract(memberGuid:string, contractGuid:string):Observable<{contract: ContractWrapperModel;message: string;}> {
    return this.contractsService.deleteMemberFromContract(memberGuid,contractGuid)
  }
  public updateMemberToContract(contractGuid:string, data:any): Observable<{ contract: ContractWrapperModel, message: string }> {
    return this.contractsService.updateMemberToContract(contractGuid,data)
  }
  checkInterDomainRedirect(contract: ContractModel|undefined):Observable<{actionAllowed:boolean}> {
    if (contract === undefined) {
      return of({actionAllowed:false})
    }
    let actionHeader = this.translateService.instant('CONFIRM.HEADERS.ATTENTION');
    let actionBody = this.translateService.instant('CONFIRM.TEXT.GO_CONTRACT',{name: contract.master_project.name})
    if (this.checkContractDomainIsCurrent(contract)) {
      return this.dialogsMTService.confirmDialog({actionHeader:actionHeader,actionBody:actionBody,buttonLabel:'CONFIRM.BUTTONS.REDIRECT'})
        .pipe(
          tap(res=>{
            if (res?.isConfirmed) {
              let contractDomain = contract.master_project.domain;
              let schema = window.location.href.split('://')[0];
              let url = schema + '://' + contractDomain + '/account/contracts/detail/' + contract.guid;
              let params = new URLSearchParams({
                  auth_token: this.tokenService.getToken(),
                  expires_in:this.tokenService.getExpireTime(),
              });
             document.location.href = url + '?' + params.toString()
            }
          }),
          filter(res=>res?.isConfirmed),
          map(res=>{return {actionAllowed:res?.isConfirmed}}),
          catchError(() => {
            return EMPTY
          }))
    } else  {
      return of({actionAllowed:true})
    }
  }
  checkContractDomainIsCurrent(contract: ContractModel):boolean {
    return this.contractDataService.currentMember?.project_setting.project.domain !== contract.master_project.domain
  }
}
